const ColorLegend = ({ isDownload = false }: { isDownload?: boolean }) => {
  const size = isDownload ? 'w-5 h-5' : 'w-4 h-4';
  const border = isDownload ? 'border border-gray-300' : '';

  return (
    <div className="flex items-center justify-center gap-8 text-sm">
      <span className={`${isDownload ? 'font-bold' : 'font-semibold'} text-gray-700`}>
        Color Scale (-log10 p-value):
      </span>
      <div className="flex items-center gap-2">
        <div className={`${size} rounded-full ${border}`} style={{ backgroundColor: '#fc0314' }}></div>
        <span>{isDownload ? 'High significance (> 8)' : '-log10(p) > 8'}</span>
      </div>
      <div className="flex items-center gap-2">
        <div className={`${size} rounded-full ${border}`} style={{ backgroundColor: '#c5008f' }}></div>
        <span>{isDownload ? 'Medium (≈ 5)' : '-log10(p) ≈ 5'}</span>
      </div>
      <div className="flex items-center gap-2">
        <div className={`${size} rounded-full ${border}`} style={{ backgroundColor: '#1e01fd' }}></div>
        <span>{isDownload ? 'Low (< 2)' : '-log10(p) < 2'}</span>
      </div>
    </div>
  );
};

export default ColorLegend;
